import {
  Dropdown,
  DropdownButton,
  DropdownMenu,
  DropdownItem,
  DropdownLabel,
} from "V2.0/common/dropdown";
import { Avatar } from "V2.0/common/avatar";
import { SidebarItem } from "V2.0/common/sidebarCatalyst";

import {
  UserIcon,
  ArrowRightStartOnRectangleIcon,
  ChevronUpIcon,
} from "@heroicons/react/16/solid";
import { QuestionMarkCircleIcon } from "@heroicons/react/24/outline";

const whitelabelUserMenuItems = [
  {
    name: "Log Out",
    href: "/logout",
    icon: <ArrowRightStartOnRectangleIcon />,
  },
];

const whitelabelOwnerMenuItems = [
  {
    name: "Account",
    href: "/account",
    icon: <UserIcon />,
  },
  ...whitelabelUserMenuItems,
];

export function UserMenu(props) {
  const { user, company } = props;

  const userMenuItems =
    user.isOwner && company?._id
      ? whitelabelOwnerMenuItems
      : whitelabelUserMenuItems;

  const initials = (user?.name && user.name[0]) ?? user?.email[0];

  return (
    <Dropdown>
      <DropdownButton as={SidebarItem}>
        <span className="flex min-w-0 items-center gap-3">
          <Avatar initials={initials} className="size-10" alt="" />
          <span className="min-w-0">
            <span className="block truncate text-sm/5 font-medium text-zinc-950 dark:text-white">
              {user?.name ?? user?.email}
            </span>
          </span>
        </span>
        <ChevronUpIcon />
      </DropdownButton>
      <DropdownMenu className="min-w-64">
        {company?.supportDeskURL && (
          <DropdownItem to={company?.supportDeskURL} target="_new">
            <QuestionMarkCircleIcon />
            <DropdownLabel>Support</DropdownLabel>
          </DropdownItem>
        )}
        {userMenuItems.map((item) => (
          <DropdownItem to={item.href}>
            {item.icon}
            <DropdownLabel>{item.name}</DropdownLabel>
          </DropdownItem>
        ))}
      </DropdownMenu>
    </Dropdown>
  );
}
